module.exports = __webpack_public_path__ + "media/images/platforms/xbox/square-5a125f8f5daabffacebfe27c244486d0.jpg";